module.exports = __webpack_public_path__ + "static/media/thumbnail_play_grey.0e3cc7fa.svg";